import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Loader2 } from 'lucide-react';

const BookingsWarningModal = ({ warning, onClose, onCancelBookings, loading }) => {
    const bookingsList = warning.bookings || [];
    
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <Card className="w-full max-w-lg">
                <CardHeader>
                    <CardTitle className="flex items-center gap-2 text-amber-600">
                        Warning: Existing Bookings
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-muted-foreground mb-4">
                        The following bookings exist on the blocked date(s). What would you like to do?
                    </p>
                    <div className="max-h-48 overflow-y-auto space-y-2 mb-4">
                        {bookingsList.map((booking, idx) => (
                            <div key={idx} className="p-2 bg-amber-50 rounded border border-amber-200 text-sm">
                                <p className="font-semibold">{booking.session_name}</p>
                                <p className="text-muted-foreground">{booking.date} at {booking.time}</p>
                            </div>
                        ))}
                    </div>
                    <div className="flex gap-2">
                        <Button variant="outline" className="flex-1" onClick={onClose}>
                            Keep Bookings
                        </Button>
                        <Button
                            className="flex-1 bg-red-600 hover:bg-red-700 text-white"
                            onClick={() => onCancelBookings(warning.blockId)}
                            disabled={loading}
                        >
                            {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}
                            Cancel and Refund
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default BookingsWarningModal;
